<template>
  <div class="row">
    <div class="center col-12">
      <h4 style="margin-bottom: 10px" class="title card-title">
        Sorteando próxima dose em:
      </h4>
      <base-timer
        v-if="secondsLeft > 0"
        :time-limit="secondsLeft"
        @timeIsUp="timeIsUp"
        :key="componentKey"
      />
    </div>
  </div>
</template>
<script>
import Card from "src/components/Cards/Card";
import BaseTimer from "src/components/Timer/BaseTimer.vue";

export default {
  name: "lottery-timer",
  components: {
    BaseTimer,
    Card,
  },
  data() {
    return {
      componentKey: 0,
      currentNextTimeLottery: null,
      secondsLeft: 0,
    };
  },
  props: {
    partyData: Object,
  },
  computed: {
    partyDataExists() {
      return this.partyData && this.partyData.eventLotteryLogs ? true : false;
    },
  },
  watch: {
    partyDataExists(value) {
      if (value) {
        this.secondsLeft = this.secondsToTheNextLottery();
      }
    },
  },
  methods: {
    timeIsUp() {
      this.$emit("timeIsUp");
      while (this.currentNextTimeLottery === this.nextTimeLottery());
      this.secondsLeft = this.secondsToTheNextLottery();
      this.componentKey += 1;
    },
    secondsToTheNextLottery() {
      return parseInt((this.nextTimeLottery() - this.currentTime()) / 1000);
    },
    nextTimeLottery() {
      let timeStamps = this.partyData.lotteryFiles.map((el) => {
        return el.timestamp;
      });
      let notPastTimeStamps = timeStamps.filter((el) => {
        return fb.fs.Timestamp.now().toMillis() < el;
      });
      const nextTime = Math.min(...notPastTimeStamps);
      this.currentNextTimeLottery = nextTime;
      return nextTime;
    },
    currentTime() {
      return fb.fs.Timestamp.now().toMillis();
    },
  },
};
</script>
<style>
.center {
  justify-content: center;
  display: grid;
}
</style>
